import React from 'react';
import i18next from 'i18next';
import moment from 'moment';
import { withTranslation } from 'react-i18next';

import { withStyles } from '@material-ui/styles';

import {
  makeHeadData,
  getHeadObj,
  getFormat,
  makeOptionList,
} from 'lib/commonLib';
import {
  modifyBonusPointLog,
  pointData,
  pointStatistics,
  reasonList,
  reasonTot,
} from 'lib/api/sales';

import FilterWrap from 'components/atoms/FilterWrap';
import TableContainer from 'components/molecules/MbTable';
import InfoTitleArea from 'components/molecules/MbTable/InfoTitleArea';
import MbSelectbox from 'components/molecules/MbSelectbox';
import BasicTable from 'components/molecules/MbBasicTable';
import SwitchingArea from 'components/organisms/SwitchingArea';
import StatisticsCommonFilter from 'components/organisms/StatisticsCommonFilter';

import PayTypeSelectBox from './PayTypeSelectBox';
import RevenuePointTextBox from './RevenuePointTextBox';
import ModifyOutlinedButton from './ModifyOutlinedButton';

const style = (theme) => ({
  sectionBox: {
    display: 'flex',
    justifyContent: 'space-between',
    '& > div': {
      width: '49%',
      marginBottom: 25,
      '&:last-child': {
        marginBottom: 25,
      },
    },
  },
});
let filterList = [];

const getFilterList = () => {
  reasonList()
    .then((response) => {
      const { data } = response.data;
      filterList = data;
    })
    .catch((error) => {
      console.log(error);
    });
};

const TotHeadList = [
  {
    id: 'PRE_CHARGE',
    label: i18next.t('선충전 합계'),
    type: 'number',
    format: '#,##0',
    displayFlag: true,
  },
  {
    id: 'BONUS_CHARGE',
    label: i18next.t('보너스 충전 합계'),
    type: 'number',
    format: '#,##0',
    displayFlag: true,
  },
  {
    id: 'TEST_CHARGE',
    label: i18next.t('테스트 충전 합계'),
    type: 'number',
    format: '#,##0',
    displayFlag: true,
  },
];

const headList = [
  {
    id: 'LABEL',
    label: i18next.t('월별사용내역'),
    orderFlag: false,
    type: 'string',
    format: '@',
    displayFlag: true,
  },
  {
    id: 'JAN',
    label: i18next.t('1월'),
    orderFlag: false,
    type: 'number',
    format: '#,##0',
    displayFlag: true,
  },
  {
    id: 'FEB',
    label: i18next.t('2월'),
    orderFlag: false,
    type: 'number',
    format: '#,##0',
    displayFlag: true,
  },
  {
    id: 'MAR',
    label: i18next.t('3월'),
    orderFlag: false,
    type: 'number',
    format: '#,##0',
    displayFlag: true,
  },
  {
    id: 'APR',
    label: i18next.t('4월'),
    orderFlag: false,
    type: 'number',
    format: '#,##0',
    displayFlag: true,
  },
  {
    id: 'MAY',
    label: i18next.t('5월'),
    orderFlag: false,
    type: 'number',
    format: '#,##0',
    displayFlag: true,
  },
  {
    id: 'JUN',
    label: i18next.t('6월'),
    orderFlag: false,
    type: 'number',
    format: '#,##0',
    displayFlag: true,
  },
  {
    id: 'JUL',
    label: i18next.t('7월'),
    orderFlag: false,
    type: 'number',
    format: '#,##0',
    displayFlag: true,
  },
  {
    id: 'AUG',
    label: i18next.t('8월'),
    orderFlag: false,
    type: 'number',
    format: '#,##0',
    displayFlag: true,
  },
  {
    id: 'SEP',
    label: i18next.t('9월'),
    orderFlag: false,
    type: 'number',
    format: '#,##0',
    displayFlag: true,
  },
  {
    id: 'OCT',
    label: i18next.t('10월'),
    orderFlag: false,
    type: 'number',
    format: '#,##0',
    displayFlag: true,
  },
  {
    id: 'NOV',
    label: i18next.t('11월'),
    orderFlag: false,
    type: 'number',
    format: '#,##0',
    displayFlag: true,
  },
  {
    id: 'DEC',
    label: i18next.t('12월'),
    orderFlag: false,
    type: 'number',
    format: '#,##0',
    displayFlag: true,
  },
];

const totCustomized = {};
const customized = {};

let initialization = false;
let initParam = {
  sDate: moment().format('YYYYMMDD'),
  eDate: moment().format('YYYYMMDD'),
};

class Statistics extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      params: initParam,
      modifyParams: [],
      list: [],
      infoMessage: '',
      listCustomized: {
        REASON: {
          makeHead: (headsMap) => {
            return `${getHeadObj(headsMap, 'REASON').label}`;
          },
          makeBody: (rowObj, headsMap) => {
            let content;
            if (rowObj['STATS_DTTM'] === 'total') {
              content = '';
            } else {
              let codeId;
              for (let i = 0; i < filterList.length; i++) {
                if (rowObj['REST_RSN_CODE'] === filterList[i].CODE_ID) {
                  codeId = filterList[i].CODE_ID;
                  break;
                } else {
                  codeId = 0;
                }
              }
              content = (
                <>
                  <div>
                    <PayTypeSelectBox
                      initialization={initialization}
                      filterList={filterList}
                      defaultCodeId={codeId}
                      label={'결제유형'}
                      orderNumber={rowObj['NO']}
                      handleOnchangeFilter={this.handleOnchangeSelectParams}
                    ></PayTypeSelectBox>
                  </div>
                </>
              );
            }

            return content;
          },
        },
        REST_RSN_CODE: {
          merged: true,
        },
        NO: {
          merged: true,
        },
        MEMO: {
          makeHead: (headsMap) => {
            return `${getHeadObj(headsMap, 'MEMO').label}`;
          },
          makeBody: (rowObj, headsMap) => {
            let content;
            if (rowObj['STATS_DTTM'] === 'total') {
              content = <></>;
            } else {
              let memo = rowObj['MEMO'];
              if (memo === null) memo = '';
              content = (
                <>
                  <div style={{ float: 'left' }}>
                    <RevenuePointTextBox
                      defaultValue={memo}
                      orderNumber={rowObj['NO']}
                      paramsKey={'memo'}
                      handleOnBlurText={this.handleOnchangeTextParams}
                    ></RevenuePointTextBox>
                  </div>
                  <div style={{ float: 'left' }}>
                    <ModifyOutlinedButton
                      modifyClick={this.modifyOnClick}
                      orderNumber={rowObj['NO']}
                    ></ModifyOutlinedButton>
                  </div>
                </>
              );
            }

            return content;
          },
        },
      },
      loading: false,
    };
  }

  modifyOnClick = (no) => {
    const { modifyParams } = this.state;

    if (typeof modifyParams[no] !== 'undefined') {
      modifyBonusPointLog(
        no,
        modifyParams[no].restRsnCode,
        modifyParams[no].memo,
        '99'
      )
        .then((response) => {
          const data = response.data;
          alert(data.message);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  handleOnchangeTextParams = (no, value, paramsKey) => {
    const { modifyParams } = this.state;
    if (typeof modifyParams[no] === 'undefined') {
      modifyParams[no] = [];
    }
    modifyParams[no][paramsKey] = value;

    this.setState({
      ...this.state,
      modifyParams: modifyParams,
    });
  };

  handleOnchangeSelectParams = (no, selectedIndex) => {
    const { modifyParams } = this.state;
    modifyParams[no] = {
      restRsnCode: filterList[selectedIndex].CODE_ID,
    };
    this.setState({
      ...this.state,
      modifyParams: modifyParams,
    });
  };

  getListData = () => {
    pointData({ year: moment().format('YYYY') })
      .then((response) => {
        const { data } = response.data;

        this.setState({
          ...this.state,
          list: data,
          loading: false,
        });
      })
      .catch((error) => {
        this.setState({
          ...this.state,
          moreFetching: false,
          error: true,
        });
      });
  };

  getTotData = () => {
    const { params } = this.state;
    const { t, locale } = this.props;
    const { sDate, eDate } = params;
    const format = getFormat(locale);

    this.setState({
      ...this.state,
      loading: true,
      error: false,
      infoMessage: t('까지의 통계 데이터입니다.', {
        date: t('term', {
          startDate: moment(sDate).format(format),
          endDate: moment(eDate).format(format),
        }),
      }),
    });

    reasonTot({ sDate: sDate, eDate: eDate })
      .then((response) => {
        const { data } = response.data;

        this.setState({
          ...this.state,
          totList: data,
        });
      })
      .catch((error) => {
        this.setState({
          ...this.state,
          moreFetching: false,
          error: true,
        });
      });
  };

  componentWillMount() {
    this.getTotData();
    getFilterList();
    this.getListData();
  }

  componentDidUpdate(prevState) {
    // const { params: prevParams } = prevState;
    // const { params } = this.state;
  }

  /**
   * 필터 선택 관련
   */
  handleOnchangeFilter = (name, index, value) => {
    const { params } = this.state;
    this.setState({
      ...this.state,
      params: { ...params, [name]: value },
    });
  };

  /**
   * 필터 초기화
   */
  handleOnReset = () => {
    initialization = true;

    this.setState({
      ...this.state,
      params: { ...initParam },
    });
  };

  getParam = (newParams) => {
    const { getInitParam } = this.state;

    initialization = false;
    if (getInitParam === false) {
      initParam = {
        ...initParam,
        ...newParams,
      };
    }

    this.setState({
      ...this.state,
      getInitParam: true,
      params: {
        ...this.state.params,
        ...newParams,
      },
    });
  };

  render() {
    const { handleOnchangeFilter, handleOnReset, getParam } = this;
    const { classes, t } = this.props;
    const {
      params,
      listCustomized,
      loading,
      list,
      totList,
      infoMessage,
      getInitParam,
    } = this.state;

    const revenueInfoMessage = t('년도 모비온 포인트 현황', {
      year: moment().format('YYYY'),
    });

    return (
      <>
        <div className={classes.sectionBox}>
          <SwitchingArea
            title={
              <>
                <InfoTitleArea
                  title={t('포인트 현황')}
                  tooltipTitle={revenueInfoMessage}
                  iconType="fainfoCircle"
                  iconColor="graph"
                />
              </>
            }
          >
            <div>
              {list && (
                <BasicTable
                  list={list}
                  sort={'asc'}
                  order={'LABEL'}
                  headCells={makeHeadData(headList)}
                  loading={loading}
                  customized={customized}
                />
              )}
            </div>
          </SwitchingArea>
          <SwitchingArea
            title={
              <>
                <InfoTitleArea
                  title={t('합계')}
                  tooltipTitle={infoMessage}
                  iconType="fainfoCircle"
                  iconColor="graph"
                />
              </>
            }
          >
            <div style={{ marginTop: 20 }}>
              {totList && (
                <BasicTable
                  list={totList}
                  sort={'asc'}
                  order={'LABEL'}
                  headCells={makeHeadData(TotHeadList)}
                  loading={loading}
                  customized={totCustomized}
                />
              )}
            </div>
          </SwitchingArea>
        </div>
        <SwitchingArea
          title={
            <>
              <InfoTitleArea
                title={t('포인트내역')}
                tooltipTitle={infoMessage}
                iconType="fainfoCircle"
                iconColor="graph"
              />
            </>
          }
        >
          <FilterWrap handleOnReset={handleOnReset}>
            <StatisticsCommonFilter
              initialization={initialization}
              getParam={getParam}
              initData={initParam}
              nonePltfomTpCodeFilter
              noneDisplayFilter
              noneExternalFilter
              displayFilterList
              useManagerFilter
            />

            {!!filterList.length && (
              <>
                <MbSelectbox
                  key="restRsnCode"
                  label={t('사유')}
                  value={params.restRsnCode}
                  itemindex={params.restRsnCode !== '00' && params.restRsnCode}
                  name="restRsnCode"
                  optionData={makeOptionList(
                    filterList,
                    'CODE_DESC',
                    'CODE_ID'
                  )}
                  optionLabelKey="CODE_DESC"
                  optionValueKey="CODE_ID"
                  handleOnchange={handleOnchangeFilter}
                  icon={false}
                />
              </>
            )}
          </FilterWrap>
          {getInitParam && (
            <>
              <TableContainer
                className={classes.root}
                dataReqPromise={pointStatistics}
                params={{ ...params }}
                sort="desc"
                order="STATS_DTTM"
                dense={true}
                customized={listCustomized}
                hasExcel
                hasTotal
                noFullScreen={true}
              />
            </>
          )}
        </SwitchingArea>
      </>
    );
  }
}

export default withTranslation()(withStyles(style)(Statistics));
